import React from "react";

const InstructorRequirements = () => {
  return (
    <>
      <p>To help create a comfortable environment, we ask all Instructors to meet these requirements for each of their Class listings:</p>
      <ul>
        <li><strong>Be responsive:</strong>&nbsp;Keep your response rate high by replying to inquiries and class requests within 24 hours.</li>
        <li><strong>Accept class requests:&nbsp;</strong>Make Users feel welcome by accepting class requests whenever you&rsquo;re available.</li>
        <li><strong>Avoid canceling on Users:&nbsp;</strong>Take cancellations seriously and try to avoid them&mdash;they&rsquo;re a huge inconvenience.</li>
        <li><strong>Maintain a high overall rating:&nbsp;</strong>Users expect a consistent level of quality, no matter what class they book.</li>
      </ul>
      <p>Find out how you&rsquo;re doing in these areas by checking your&nbsp;rating. Instructors who consistently fall below average ratings could be penalized and suspended.</p>
    </>
  );
};

export default InstructorRequirements;
